module.exports = __webpack_public_path__ + "static/bar01_1_mobile-bd24575512301b0f06ab0d4adc69a1c1.png";